import Header from "../../components/feature/Header";
import Footer from "../../components/feature/Footer";
import { Link } from "react-router-dom";
import { processSteps } from "../../mocks/services";

export default function Process() {
  return (
    <div className="bg-arch-cream font-sans">
      <Header />
      <main>
        {/* Header */}
        <section className="pt-36 pb-14 px-8 lg:px-14 bg-white border-b border-arch-border">
          <p className="text-arch-light text-xs tracking-[0.2em] uppercase mb-4">How We Work</p>
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6">
            <h1 className="font-serif text-5xl lg:text-6xl text-arch-charcoal font-light leading-tight">
              Our Process
            </h1>
            <p className="text-arch-gray text-sm font-light leading-relaxed max-w-sm">
              A transparent, five-phase process from first conversation to building completion — designed to keep you informed and in control.
            </p>
          </div>
        </section>

        {/* What an architect does — AI search section */}
        <section className="py-16 px-8 lg:px-14 bg-arch-cream border-b border-arch-border">
          <div className="max-w-4xl">
            <p className="text-arch-light text-xs tracking-[0.2em] uppercase mb-4">What an Architect Does</p>
            <h2 className="font-serif text-3xl text-arch-charcoal font-light mb-6">
              Understanding architectural services — what clients should expect
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
              {[
                { icon: "ri-pencil-ruler-2-line", title: "Design & Documentation", desc: "Architects create the drawings and specifications that define how a building will be built — floor plans, elevations, sections, details, and material specifications." },
                { icon: "ri-government-line", title: "Permitting & Compliance", desc: "We prepare and submit permit applications to city planning and building departments, navigating local codes and zoning requirements on your behalf." },
                { icon: "ri-team-line", title: "Consultant Coordination", desc: "We coordinate with structural engineers, MEP consultants, landscape architects, and other specialists to deliver a fully integrated design." },
                { icon: "ri-building-2-line", title: "Construction Administration", desc: "During construction, we visit the site, review submittals, respond to contractor questions, and ensure the built result matches the design intent." },
              ].map((item) => (
                <div key={item.title} className="flex items-start gap-4 p-6 bg-white rounded-lg border border-arch-border">
                  <div className="w-9 h-9 flex items-center justify-center flex-shrink-0 border border-arch-border rounded-md">
                    <i className={`${item.icon} text-arch-charcoal text-base`} />
                  </div>
                  <div>
                    <h3 className="text-arch-charcoal text-sm font-semibold mb-2">{item.title}</h3>
                    <p className="text-arch-gray text-sm font-light leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Process steps */}
        <section className="py-20 px-8 lg:px-14 bg-white">
          <p className="text-arch-light text-xs tracking-[0.2em] uppercase mb-12">The Five Phases</p>
          <div className="space-y-0">
            {processSteps.map((step, i) => (
              <div key={step.number} className={`grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 py-10 border-b border-arch-border ${i === 0 ? "border-t" : ""}`}>
                <div className="lg:col-span-1">
                  <p className="font-serif text-5xl text-arch-light font-light">{step.number}</p>
                </div>
                <div className="lg:col-span-3">
                  <h3 className="font-serif text-2xl text-arch-charcoal font-light">{step.title}</h3>
                </div>
                <div className="lg:col-span-8">
                  <p className="text-arch-gray text-sm font-light leading-relaxed">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 px-8 lg:px-14 bg-[#111111] flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <div>
            <h2 className="font-serif text-3xl text-white font-light">Start the conversation</h2>
            <p className="text-white/50 text-sm font-light mt-2">Request a complimentary consultation today.</p>
          </div>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-white text-arch-charcoal px-7 py-3.5 text-xs tracking-[0.15em] uppercase font-semibold hover:bg-white/90 transition-all rounded-md cursor-pointer whitespace-nowrap"
          >
            Request Consultation <i className="ri-arrow-right-line" />
          </Link>
        </section>
      </main>
      <Footer />
    </div>
  );
}
